export default function ContactRow({ rowItem }) {
  return (
    <div className="row">
      <div className="key">{rowItem.DESG} :</div>
      <div className="value">{rowItem.CONTACT_NO}</div>
    </div>
  );
}
